import { render, staticRenderFns } from "./GrandTable.vue?vue&type=template&id=8f266da6&scoped=true"
import script from "./GrandTable.vue?vue&type=script&lang=js"
export * from "./GrandTable.vue?vue&type=script&lang=js"
import style0 from "./GrandTable.vue?vue&type=style&index=0&id=8f266da6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f266da6",
  null
  
)

export default component.exports